export default __webpack_public_path__ + "img/Poppins-Regular_dd1ec14.eot";